import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import ListHeader from "components/Headers/ListHeader";
import axiosConfig from "consts/axiosConfig";
import Swal from "sweetalert2";
import { simpleWebRequest } from "consts/Constants";
import { states } from "consts/USSTATES";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import moment from "moment";
import FilterModal from "./FilterModal";
import { useDownloadExcel } from "react-export-table-to-excel";

export default function ClientsReports(props) {
  const [loading, setLoading] = useState(false);
  const [items, setITems] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Clients",
    sheet: "Clients",
  });
  const getItems = () => {
    setFromDate(null);
    setToDate(null);
    setLoading(true);
    axiosConfig
      .get("user/reports/clients")
      .then((res) => {
        setLoading(false);
        setITems(res.data.result.clients);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const filterReports = () => {
    setShowModal(false);
    var from = moment(
      fromDate.year + "-" + fromDate.month + "-" + fromDate.day
    ).format("yyyy-MM-DD");
    var to = moment(toDate.year + "-" + toDate.month + "-" + toDate.day).format(
      "yyyy-MM-DD"
    );
    setLoading(true);
    axiosConfig
      .get(`user/reports/clients?start=${from}&end=${to}`)
      .then((res) => {
        setLoading(false);
        setITems(res.data.result.clients);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getItems();
  }, []);
  const renderItems = () => {
    if (loading) {
      return (
        <tr className="text-center">
          <td colSpan={7}>
            <Spinner color="info" size="xl" />
          </td>
        </tr>
      );
    } else if (items) {
      return items.map((tr) => {
        return (
          <tr key={tr.id} className="text-center">
            <td>{tr.firstname}</td>
            <td>{tr.lastname}</td>
            <td>{tr.zipcode}</td>
            <td>{tr.address}</td>
            <td>{tr.city}</td>
            <td>{tr.state}</td>
            <td>{tr.country}</td>
            <td>{tr.phones ? tr.phones.join() : ""}</td>
            <td>{tr.emails ? tr.emails.join() : ""}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr className="text-center">
          <td colSpan={7}>
            <p>No Clients yet!</p>
          </td>
        </tr>
      );
    }
  };
  return (
    <>
      <FilterModal
        showModal={showModal}
        toggleModal={setShowModal}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        filterReports={filterReports}
        title="Filter"
      />
      <ListHeader
        name="Clients Report"
        parentName="Dashboard"
        setShowModal={setShowModal}
        btnName="Filter"
        setExtraButton={onDownload}
        extraBtnName="Export"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader>
                <h3 className="mb-0">
                  Clients{" "}
                  <span className="text-muted">
                    {fromDate && toDate
                      ? `from ${moment(
                          fromDate.year +
                            "-" +
                            fromDate.month +
                            "-" +
                            fromDate.day
                        ).format("yyyy-MM-DD")} 
                  to 
                  ${moment(
                    toDate.year + "-" + fromDate.month + "-" + fromDate.day
                  ).format("yyyy-MM-DD")}`
                      : ""}
                  </span>
                  {fromDate && toDate ? (
                    <Button color="link" size="sm" onClick={() => getItems()}>
                      Reset
                    </Button>
                  ) : (
                    <></>
                  )}
                </h3>
              </CardHeader>

              <table
                className="table table-striped table-responsive"
                ref={tableRef}
              >
                <thead>
                  <tr>
                    <th>FIRSTNAME</th>
                    <th>LASTNAME</th>
                    <th>ZIPCODE</th>
                    <th>ADDRESS</th>
                    <th>CITY</th>
                    <th>STATE</th>
                    <th>COUNTRY</th>
                    <th>PHONE</th>
                    <th>EMAIL</th>
                  </tr>
                </thead>
                <tbody>{renderItems()}</tbody>
              </table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
